import service from "@/api/service";
import { GetRequest, RegisterRequest } from "@/api/item-name-shop/request";
import { GetResponse } from "@/api/item-name-shop/response";
import { CommonResponse } from "@/api/response";

/**
 * 項目名設定情報取得APIをコールします。
 *
 * @return GetResponse
 */
export async function get(getRequest: GetRequest) {
  const response = await service.post("/get-item-name-shop", getRequest);
  return response.data as GetResponse;
}

/**
 * 項目名設定登録更新APIをコールします。
 *
 * @param registerRequest
 * @return CommonResponse
 */
export async function register(registerRequest: RegisterRequest) {
  const response = await service.post(
    "/regist-item-name-shop",
    registerRequest
  );
  return response.data as CommonResponse;
}
